import React from "react";

import tw, { styled } from "twin.macro";
import RecentNews from "./RecentNews";
import _ from "lodash";
import UpcomingGames from "./UpcomingGames";
import TwitterTimeline from "./TwitterTimeline";
import RosterHistory from "./RosterHistory";
import ScheduleHistory from "./ScheduleHistory";
import ContactWidget from "./ContactWidget";
import InstagramFeed from "./InstagramFeed";

import ImageOne from "../images/8-WCBL-CHAMPIONSHIPS.jpg";
import ImageThree from "../images/4700-plus-FANS.jpg";
import ImageTwo from "../images/voted-best-ballpark.jpg";
import ImageFour from "../images/AcademyGraphic.jpg";

const Container = styled.div`
  ${({ isHomePage }) =>
    isHomePage &&
    tw`lg:-mt-52 lg:z-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1`}

  > *:not(:last-child) {
    ${tw`mb-4 sm:mb-8`}
  }
`;

const ImageCard = styled.img``;

const SidePanel = ({
  isHomePage,
  location,
  data,
  color,
  homeTeams,
  logoUrl,
  site,
  timelineAccount,
}) => {
  const isSchedulePage =
    !_.isNil(location) && _.get(location, "pathname", "").includes("/schedule");
  const isRosterPage =
    !_.isNil(location) && _.get(location, "pathname", "").includes("/roster");

  return (
    <Container isHomePage={isHomePage}>
      {/* {isRosterPage && (
        <RosterHistory currentPathname={_.get(location, "pathname", "")} data={data} color={color} site={site}/>
      )} */}
      {/* {isSchedulePage && (
        <ScheduleHistory currentPathname={_.get(location, "pathname", "")} data={data}  color={color} site={site}/>
      )} */}
      {!isHomePage && (
        <RecentNews data={data} color={color} logoUrl={logoUrl} site={site} />
      )}
      {!isHomePage && <ContactWidget color={color} site={site} />}
      {isHomePage && (
        <UpcomingGames
          data={data}
          color={color}
          site={site}
          homeTeams={homeTeams}
        />
      )}
      {isHomePage && timelineAccount && (
        <TwitterTimeline timelineAccount={timelineAccount} />
      )}
      {/* {isHomePage &&
        !_.isEmpty(_.get(data, "allInstaNode.edges", [])) &&
        site === "academy" && <InstagramFeed data={data} site={site} />} */}
      {isHomePage && site === "dawgs" && (
        <>
          <ImageCard src={ImageOne} />
          <ImageCard src={ImageTwo} />
          <ImageCard src={ImageThree} />
        </>
      )}
      {isHomePage && site === "academy" && (
        <>
          <ImageCard src={ImageFour} />
        </>
      )}
    </Container>
  );
};

export default SidePanel;
